module.exports = __webpack_public_path__ + "img/bg.e104d297.png";